import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { CustomFormsModule } from 'ngx-custom-validators';

/* Local components */
import { ProfessionalComponent } from './professional.component';
import { ProfessionalHomeComponent } from './components/home/professional-home.component';
import { ProfessionalAttachedComponent } from './components/attached/professional-attached.component';
import { ProfessionalRankingComponent } from './components/ranking/list/professional-ranking.component';
import { ProfessionalRankingClassifComponent } from './components/ranking/classification/professional-ranking-classif.component';
import { ProfessionalRankingHistoryComponent } from './components/ranking/history/professional-ranking-history.component';

/* Routes */
import { ProfessionalRoutingModule } from './professional-routing.module';

/* Interceptor */
import { Interceptor } from 'src/app/core/interceptors/http-request-interceptor';
import { ThemeModule } from 'src/app/@theme/theme.module';

@NgModule({
    declarations: [
        ProfessionalComponent,
        ProfessionalHomeComponent,
        ProfessionalAttachedComponent,
        ProfessionalRankingComponent,
        ProfessionalRankingClassifComponent,
        ProfessionalRankingHistoryComponent,
    ],
    imports: [CommonModule, RouterModule, ProfessionalRoutingModule, ThemeModule, Interceptor],
})
export class ProfessionalModule {}
